$(function () {
  // 初期のカートデータ
  getCartData ();  
  // カートの商品数が変わったら
  $(document).on('change', '.quantity__input--higashine', function() {
    console.log("【カート内の商品数が変更されました】");
    setTimeout(getCartData, 1500);
  });
  // カート内の商品が削除されたら
  $(document).on('click', '.remove-button--higashine', function() {
    console.log("【カート内の商品が削除されました】");
    setTimeout(getCartData, 1500);
  });
});
  
function getCartData () {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    cache: false,
    dataType: 'json'
  })
  .then(
    // 通信成功時
    function (cart) {    
      var normal_order = false;
      var pre_order = false;
      var shipping_time = [];
      
      var line = cart['items'].length;
      console.log("カート内商品種別数：",line);

      for (var i=0; i<line; i++) { 
        var properties = JSON.stringify(cart['items'][i]['properties']); //JSONデータを文字列に変換
        var properties = properties.slice(1); //最初の文字('{')削除
        var properties = properties.slice(0,-1); //最後の文字('}')削除
        var properties = properties.split(':');
        
        if (!(properties[0].indexOf("予約") > -1)) {
          var normal_order = true;
          console.log("通常販売商品:",normal_order);
        } else {
          var pre_order = true;
          console.log("予約販売商品:",pre_order);       
          shipping_time.push(properties[properties.length-1]);         
        }
      }
      if(normal_order && pre_order) {
        $(".h-cart-normal-and-pre-attention").removeClass("h-hidden");
        $(".h-cart-pre-attention").addClass("h-hidden");
        $(".cart__footer").addClass("h-hidden");
        console.log("【購入不可】通常販売商品と予約販売商品は同時購入できません");
      } else if (normal_order) {
        $(".h-cart-normal-and-pre-attention").addClass("h-hidden");
        $(".h-cart-pre-attention").addClass("h-hidden");
        $(".cart__footer").removeClass("h-hidden");
        $(".h-delivery").removeClass("h-hidden");
        console.log("【購入ＯＫ】通常販売：配達日時指定あり");         
      } else if (pre_order) {
        console.log(shipping_time);
        if (shipping_time.every(v => v === shipping_time[0])) {
          $(".h-cart-normal-and-pre-attention").addClass("h-hidden");
          $(".h-cart-pre-attentio").addClass("h-hidden");
          $(".cart__footer").removeClass("h-hidden");
          $(".h-delivery").addClass("h-hidden");
          console.log("【購入ＯＫ】予約販売（1商品もしくは発送予定時期が同じ）：配達日時指定なし");            
        } else {
          $(".h-cart-normal-and-pre-attention").addClass("h-hidden");
          $(".h-cart-pre-attention").removeClass("h-hidden");
          $(".cart__footer").addClass("h-hidden");
          $(".h-delivery").addClass("h-hidden");
          console.log("【購入不可】発送予定時期が異なる予約販売商品は同時購入できません");       
        }
      } else  {
        console.log("カートに商品が入っていない、もしくはなんらかのエラー");         
      }
    },
    // 通信失敗時
    function () {
      console.log("cart.js 読み込み失敗");
    }
  );
};

